
import React from "react";

export default function Instrukcja() {
  const pdfUrl = "/instrukcja.pdf";

  return (
    <div className="instruction-page">
      <style>{`
        .instruction-page {
          min-height: 100vh;
          background: #f4f6fa;
          padding: 70px 20px;
          font-family: Arial, sans-serif;
          color: #202b3c;
        }

        .instruction-container {
          max-width: 850px;
          margin: 0 auto;
          text-align: center;
        }

        .instruction-header {
          margin-bottom: 40px;
        }

        .pdf-icon {
          display: inline-block;
          background: #e53935;
          color: white;
          padding: 12px 17px;
          border-radius: 10px;
          font-weight: bold;
          margin-bottom: 20px;
        }

        .instruction-label {
          display: block;
          color: #64748b;
          font-size: 12px;
          letter-spacing: 2px;
          font-weight: bold;
        }

        .instruction-header h1 {
          font-size: 36px;
          margin: 15px 0;
        }

        .instruction-header p {
          color: #64748b;
          line-height: 1.6;
        }

        .instruction-card {
          background: white;
          border-radius: 18px;
          padding: 40px;
          box-shadow: 0 10px 35px rgba(0,0,0,0.06);
        }

        .document-icon {
          font-size: 45px;
        }

        .instruction-card h2 {
          font-size: 20px;
          overflow-wrap: anywhere;
        }

        .instruction-card p {
          color: #64748b;
        }

        .download-button {
          display: block;
          padding: 15px 20px;
          border-radius: 9px;
          text-decoration: none;
          font-weight: bold;
          cursor: pointer;
          margin: 20px auto;
          max-width: 300px;
          background: #16a34a;
          color: white;
          transition: 0.2s;
        }

        .download-button:hover {
          background: #15803d;
        }

        .pdf-preview {
          width: 100%;
          height: 600px;
          border: 1px solid #e2e8f0;
          border-radius: 10px;
          margin: 25px 0;
        }

        .instruction-card small {
          color: #94a3b8;
        }

        .instruction-container footer {
          margin-top: 40px;
          color: #94a3b8;
          font-size: 13px;
        }

        @media (max-width: 600px) {
          .instruction-page {
            padding: 35px 15px;
          }

          .instruction-header h1 {
            font-size: 28px;
          }

          .instruction-card {
            padding: 25px 15px;
          }

          .pdf-preview {
            height: 400px;
          }
        }
      `}</style>

      <div className="instruction-container">

        <div className="instruction-header">
          <div className="pdf-icon">PDF</div>

          <span className="instruction-label">
            STREFA POBIERANIA
          </span>

          <h1>Instrukcja obsługi</h1>

          <p>
            Pobierz instrukcję w formacie PDF.
            Znajdziesz w niej wszystkie niezbędne informacje.
          </p>
        </div>

        <div className="instruction-card">

          <h2>Instrukcja obsługi</h2>

          <p>Dokument w formacie PDF</p>

          <a
            href={pdfUrl}
            download="instrukcja.pdf"
            className="download-button"
          >
            ↓ Pobierz instrukcję
          </a>

          <small>Format pliku: PDF</small>

        </div>

        <footer>
          © {new Date().getFullYear()} Wszystkie prawa zastrzeżone
        </footer>

      </div>
    </div>
  );
}
